import { Button, Flex, Text } from "@radix-ui/themes";
import { useI18n } from "@/i18n";

interface ErrorStateProps {
  onRetry: () => void;
}

export function ErrorState({ onRetry }: ErrorStateProps) {
  const { t } = useI18n();
  return (
    <Flex direction="column" align="center" justify="center" gap="3" className="rk-state-panel rk-state-error">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <line x1="12" y1="8" x2="12" y2="13" />
        <line x1="12" y1="16" x2="12" y2="16.01" />
      </svg>
      <Text size="2" color="gray" align="center" style={{ maxWidth: 440 }}>
        {t("state.error")}
      </Text>
      <Button size="2" variant="soft" onClick={onRetry}>
        {t("state.retry")}
      </Button>
    </Flex>
  );
}
